module.exports = {
	"fr": {
		"(Will be) delivered": "Est livré",
		"(Will be) partially delivered": "Partiellement livré",
		"(excl. btw - {{d.promoCode}} - Valid until {{d.endDate | date: 'dd/MM/yyyy'}})": "(Hors TVA - {{d.promoCode}} - Valable jusqu'au {{d.endDate | date: 'dd/MM/yyyy'}})",
		".csv file, max. 5MB": "Fichier CSV, max. 5 MB",
		"<a href=\"http://www.profficina.be\" target=\"_blank\" class=\"link\">www.profficina.be</a>": "<a href=\"http://www.profficina.be/fr/index.html\" target=\"_blank\" class=\"link\">www.profficina.be</a>",
		"<a href=\"http://www.profficina.be/nl/algemene-voorwaarden.html\" target=\"_blank\" class=\"link\">Terms and conditions</a>": "<a href=\"http://www.profficina.be/fr/conditions-generales.html\" target=\"_blank\" class=\"link\">Conditions générales d’utilisation</a>",
		"<a href=\"http://www.profficina.be/nl/privacy-beleid.html\" target=\"_blank\" class=\"link\">Privacy policy</a>": "<a href=\"http://www.profficina.be/fr/protection-de-la-vie-privee.html\" target=\"_blank\" class=\"link\">Protection de la vie privée</a>",
		"<b>Niet te reserveren</b>": "<b>Non réservable.</b>",
		"<b>Zonder korting</b>": "<b>À réserver sans réduction.</b>",
		"<strong>Do not order</strong> the products.": "<strong>Ne pas commander</strong> les produits.",
		"<strong>Opgelet!</strong> Geen retours mogelijk. Levering van zodra voorradig en zolang de voorraad strekt.": "Il sera aussi impossible de retourner les vaccins. Ceux-ci seront livrés dès que nous les avons en stock et jusqu’à épuisement des réserves.",
		"<strong>Opgelet!</strong> U kan na 28 februari 2021 uw gereserveerde aantallen niet meer wijzigen.": "Veuillez également noter que, dès le 28 février prochain, vous ne pourrez plus modifier les quantités réservées. ",
		"<strong>Opgelet!</strong> het maximale reservatieniveau voor de Influvac vaccins werd bereikt. Het is dus niet meer mogelijk om deze te reserveren. U kan uw eerder gereserveerde Influvac vaccins wel nog raadplegen, maar niet langer wijzigen.": "<strong  style=\"color: #82BC00;\">Attention : </strong> le seuil de réservation des vaccins Influvac a été franchi. Cela signifie qu'il n'est plus possible de les réserver. Vous pouvez toujours consulter vos réservations de vaccins Influvac, mais vous ne pouvez plus les modifier.",
		"<strong>Order</strong> the products <strong>anyway</strong> via the customer service ('special order').": "<strong>Commander</strong> les produits via le service clientèle (‘Commandes spéciales’). ",
		"A question? A suggestion?": "Une question ? Une suggestion ?",
		"ALPHARIX TETRA 2021-2022 0,5 ML 1 WWSP": "ALPHARIX TETRA 2021-2022 0,5 ML 1 SER A JET",
		"APB category": "Catégorie APB",
		"APB-number": "N° d'autorisation",
		"About us": "À propos de nous",
		"Access is denied": "Accès refusé",
		"Account": "Account",
		"Active ingredients": "Principes actifs",
		"Add": "Ajouter",
		"Add package": "Verzending toevoegen",
		"Add products or import a CSV file with your order.": "Entrez vos produits ou importez un fichier csv avec votre commande.",
		"Add to shopping cart": "Ajouter au panier",
		"Add {{ vm.product.quantityToAddForHighestDiscount }} pcs. for {{ vm.product.highestDiscount.discount }}% discount": "Add {{ vm.product.quantityToAddForHighestDiscount }} pcs. for {{ vm.product.highestDiscount.discount }}% discount",
		"Added products to your shoppingcart": "Les produits ont été ajoutés au panier.",
		"Address": "Adresse",
		"Al mijn verzendingen": "Al mijn verzendingen",
		"All categories": "Toutes les catégories",
		"All discounts": "Toutes les réductions",
		"All my rental requests": "Toutes mes demandes",
		"All my rented products": "Mes demandes de location",
		"All news": "Toutes les nouvelles",
		"All partnerships": "Tous les partenariats",
		"All pharmacies": "Toutes les pharmacies",
		"All products": "Tous les produits",
		"All products of this supplier or in your contract.": "Tous les produits de ce labo sont dans votre contrat.",
		"All rental products": "Tous les produits de location",
		"All sellers": "Tous les fournisseurs",
		"All vendors": "Tous les fournisseurs",
		"Amount": "Montant",
		"An error occured when adding products to your shoppingcart, please try again": "Un problème inattendu est survenu en ajoutant des produits à votre panier. Veuillez réessayer. Nos excuses pour l’inconvénient.",
		"An error occurred during the confirmation of the order. Please contact the customer support.": "Un problème inattendu est survenu lors de la confirmation de votre commande. Veuillez prendre contact avec le service clientèle. Nos excuses pour l’inconvénient.",
		"An error occurred during the re order. Please contact the customer support.": "Un problème inattendu est survenu lors de la confirmation de votre commande. Veuillez prendre contact avec le service clientèle. Nos excuses pour l’inconvénient.",
		"An overview of all rental products since 2019.": "Un aperçu de toutes vos locations depuis 2019.",
		"Are you sure you want to clear your shopping cart?": "Êtes-vous certain de vouloir vider votre panier ?",
		"At least": "Au moins",
		"Attention!": "Attention !",
		"Available": "Stock suffisant",
		"Back to overview": "Retour à l’aperçu",
		"Batch number": "Lot",
		"Below are some useful links:": "Veuillez trouver ci-dessous quelques liens pratiques :",
		"Bewaren": "Réserver",
		"Billing address": "Adresse de facturation",
		"Black Friday": "Black Friday",
		"Box.": "Boîte",
		"Box:": "Boîte:",
		"Box: {{vm.partnership.partner.address.boxNumber}}": "Boîte: {{vm.partnership.partner.address.boxNumber}}",
		"Brand": "Marque",
		"Brands": "Marques",
		"Buy": "Acheter",
		"CNK": "CNK",
		"CTI extended": "CTI extended",
		"Call": "Appelez ",
		"Cancel": "Annuler",
		"Cancelled": "Annulé",
		"Categories": "Catégorisatie",
		"Categorisation": "Catégorisation",
		"Certificates": "Certificats",
		"Certificates headerlink": "Certificats d'analyse",
		"Certificates introtext": "<p>Chaque matière première est accompagnée d'un certificat d'analyse. C’est aussi le cas de <strong>Febelcare Elements</strong>. <strong>Grâce à Profficina</strong>, vous avez accès à ces certificats quand et où vous voulez !</p><p>Pour obtenir un certificat d'analyse, il suffit de saisir ci-dessous le numéro de lot, le CNK ou le nom du produit affiché sur l'emballage. Si aucune correspondance n’est trouvée, cela signifie que le numéro de lot a expiré ou que le certificat n'a tout simplement pas été enregistré dans la base de données.</p><p>En cas de problème, merci de prendre contact avec notre service clientèle. Ils se feront un plaisir de vous aider.</p>",
		"Certificates title": "À la recherche d’un certificat d'analyse ?",
		"Change": "Modifier ",
		"Check stock": "Consultez le stock",
		"Check your order": "Vérifiez votre commande",
		"Checking stock...": "En traitement...",
		"City": "Ville",
		"Clear": "Supprimer",
		"Clear all": "Supprimer tout",
		"Clear all filters": "Supprimer tous les filtres",
		"Clear selection": {
			"Datetimepicker tooltips": "Supprimer"
		},
		"Clear shopping cart": "Vider panier",
		"Click here to see the complete list.": "Cliquez ici pour voir la liste.",
		"Close": "Fermer",
		"Close and don't show again": "Ne plus afficher",
		"Close the picker": {
			"Datetimepicker tooltips": "Fermer calendrier"
		},
		"Company number": "Numéro d'entreprise",
		"Compose your panacea by choosing products from the list below.": "Composez votre panaché à l’aide des produits ci-dessous.",
		"Composition": "Composition",
		"Confirm": "Confirmer",
		"Confirm order": "Confirmer commande",
		"Confirmation": "Confirmation",
		"Conservation": "Bewaring",
		"Contact": {
			"$$noContext": "Contact",
			"Contact page title": "Contact"
		},
		"Contact <a href=\"mailto:support@profficina.be\" class=\"link\">support@profficina.be</a> for further assistance.": "Pour recevoir des renseignements ou des conseils, veuillez vous adresser à <a href=\"mailto:support@profficina.be\" class=\"link\">support@profficina.be</a>.",
		"Contact person": "Personne à contacter",
		"Contacts": "Contact",
		"Continue shopping": "Poursuivre vos achats",
		"Continue without updating cart": "Continuer sans mise à jour panier",
		"Contra indication": "Contre-indication",
		"Contract name": "Nom contrat",
		"Contracts": "Contrats",
		"Counter discount": "Réduction compteur",
		"Created": "Créé",
		"Current discount": "Réduction actuelle",
		"Current filters": "Filtres actuels",
		"Currently you do not have any Febelco Partner or Agios contract.": "Vous n’avez pas encore de contrat pour ce partenariat.",
		"Customer number": "N° client",
		"DD-MM-YYYY": "JJ-MM-AAAA",
		"Date": "Date",
		"De minimumhuurtijd bedraagt 7 kalenderdagen. Er worden €60 transportkosten (AP excl BTW) aangerekend; deze kost omvat leveren, ophalen, reiniging en de administratieve afhandeling. ESRI zal niets factureren aan de patiënt. Alle facturatie verloopt via uw apotheek.": "Location minimum de 7 jours calendriers. Les frais de transport de €60 (Prix pharmacie, hors TVA) qui seront facturés, incluent la livraison, l’enlèvement, le nettoyage et l’administration. ESRI ne facturera rien au patient. Toute facturation passera par votre pharmacie.",
		"Decrement Hour": {
			"Datetimepicker tooltips": "Diminuer l'heure"
		},
		"Decrement Minute": {
			"Datetimepicker tooltips": "Diminuer les minutes"
		},
		"Decrement Second": {
			"Datetimepicker tooltips": "Diminuer les secondes"
		},
		"Deficit": "Déficit",
		"Delayed deliveries": "Livraisons réparties sur l'année",
		"Delete": "Supprimer",
		"Deliver earlier": "Avancer le délai de livraison",
		"Delivered": "Livré",
		"Deliveries": "Livraisons",
		"Delivery Date": "Date de livraison prévue",
		"Delivery address": "Adresse de livraison",
		"Delivery nr.": "N° livraison",
		"Deposit": "Caution",
		"Deposit not refunded": "Dépôt non remboursé",
		"Deposit refunded": "Restitution caution",
		"Deposit:": "Caution:",
		"Depth": "Profondeur",
		"Description": "Description",
		"Detail": "Détails",
		"Diameter": "Diamètre",
		"Dimensions": "Dimensions",
		"Discount": "Réduction",
		"Discount date": "Date réduction",
		"Discount expires today": "Réduction expire aujourd'hui.",
		"Discount on order total": "Réduction sur la totalité de votre commande ",
		"Discount on total order at": "Réduction sur la totalité de votre commande chez ",
		"Discount type": "Réduction",
		"Discounts": "Réductions",
		"Discounts only": "Uniquement des réductions",
		"Discover all promotions!": "Découvrez toutes les promotions !",
		"Discover the <a class=\"link-primary\" ui-sref=\"seller.rentProductOverview({sellerId: vm.tgzId})\">Homecare rental range</a>.": "Découvrez nos <a class=\"link-primary\" ui-sref=\"seller.rentProductOverview({sellerId: vm.tgzId})\">Produits de soins à domicile en location</a>.",
		"Displayname": "Nom d'affichage",
		"Displays": "Displays",
		"Dit product wordt rechtstreeks geleverd bij de patiënt.": "Ce produit sera livré au patient à l’aide de la partie externe ESRI.",
		"Document (pdf)": "Document (PDF)",
		"Document library": "Infothèque",
		"Documents": "Documents",
		"Download": "Télécharger",
		"Download PDF": "Télécharger PDF",
		"Drag your file here or": "Faites glisser le fichier ici ou",
		"Dutch": "Néerlandais",
		"E-mail address and language for order confirmations:": "Vos commandes seront confirmées sur cette adresse:",
		"Email address": "Adresse e-mail",
		"Enkel te bestellen via uw vertegenwoordiger": "À commander via votre délégué",
		"Enter e-mailadress": "Entrez adresse e-mail",
		"Error": "Erreur",
		"Estimated Delivery Date": "Délai de livraison prévu",
		"Expected delivery date": "Date de livraison prévue",
		"Expires": "Expire",
		"Expires within {{productDiscount.daysLeft}} days": "Expire dans {{productDiscount.daysLeft}} jours",
		"Expires within {{vm.product.daysLeftUntilDiscountExpires}} days": "Expire dans {{vm.product.daysLeftUntilDiscountExpires}} jours",
		"Expiry date": "Date de péremption",
		"Extra info": "Informations supplémentaires",
		"FAQ": "FAQ",
		"Fast Order": "Commande rapide",
		"Fast order": "Commande rapide",
		"Fax:": "Fax:",
		"Featured products": "Produits sous la loupe",
		"Febelco stock info": "Stock info Febelco",
		"Filter": "Filtre",
		"Flu vaccines": "Vaccins anti-grippe ",
		"Following products can be ordered via 'special order', should the product not be in stock at the moment.": "Si les produits suivants ne sont plus en stock, ils peuvent être commandés via ‘Commandes spéciales’. ",
		"For more information about this contract, please contact your relationship manager.": "Pour de plus amples renseignements sur ce contrat, merci de vous adresser à votre chargé de relations.",
		"For more information about this contract, please contact your supplier.": "Pour de plus amples renseignements sur ce contrat, merci de vous adresser au labo. ",
		"French": "Français",
		"Frequently asked questions": "Questions fréquemment posées",
		"From": "Du",
		"From date must be greater than contract start date.": "La date doit être supérieure ou égale à la date de début du contrat.",
		"From&nbsp;{{vm.product.minOrderAmount}}": "à partir de&nbsp;{{vm.product.minOrderAmount}}",
		"GPM": "MBB",
		"Gelieve hieronder in te geven waar de producten geleverd mogen worden en wie ESRI kan contacteren om te verwittigen w.b. de levering.": "Veuillez ajouter ci-dessous une adresse pour la livraison des produits, ainsi que la personne qui peut être contactée par ESRI à propos de la livraison.",
		"General": "Général",
		"Go to today": {
			"Datetimepicker tooltips": "Aujourd'hui"
		},
		"Griepvaccins 2021-2022": "Vaccins anti-grippe 2021-2022",
		"Gross profit margin": "Marge bénéficiaire brute",
		"Gross profit margins (GPM) are calculated based on the pharmacy and public price (non-binding recommended prices).": "Les marges bénéficiaires brutes (MBB) sont calculées sur base du prix pharmacien et du prix public (prix conseillés non contraignants).",
		"Height": "Hauteur",
		"Hello": "Bonjour",
		"Help": "FAQ",
		"Hier krijgt u een overzicht van alle Thuisgezondheidszorg producten in uw bezit en alle huuraanvragen via Profficina.": "Consultez ici les produits Soins à domicile que vous louez actuellement ainsi que vos demandes de location sur Profficina.",
		"Hier krijgt u een overzicht van alle bestellingen die u bij Profficina geplaatst heeft.": "Consultez ici toutes vos commandes Profficina.",
		"Hier krijgt u een overzicht van alle producten die u bij Febelco gereserveerd heeft.": "Consultez ici toutes vos réservations auprès de Febelco.",
		"Hieronder kan u uw reservatie van de afgelopen 12 maanden terugvinden. Gelieve met uw klantendienst contact op te nemen indien u een reservatie wenst te annuleren.": "Vous trouverez ci-dessous vos réservations des douze derniers mois. Si vous souhaitez annuler une réservation, veuillez prendre contact avec votre service clientèle.",
		"Home": "Accueil",
		"Homepage": "Page d’accueil",
		"How can you enjoy this partnership?": "Comment profiter de cet avantage ?",
		"INFLUVAC S 2021-2022 0,5 ML 1 WWSP": "INFLUVAC S 2021-2022 0,5 ML 1 SER A JET",
		"In progress": "En cours de traitement",
		"In the spotlight": "Sous la loupe",
		"Increment Hour": {
			"Datetimepicker tooltips": "Augmenter l'heure"
		},
		"Increment Minute": {
			"Datetimepicker tooltips": "Augmenter les minutes"
		},
		"Increment Second": {
			"Datetimepicker tooltips": "Augmenter les secondes"
		},
		"Indication": "Indication",
		"Influvac niet meer reserveerbaar na bericht van de leverancier op 1/4/20.": "Influvac ne peut plus être réservé après un message du fournisseur le 1/4/20.",
		"Info": "Informations",
		"Invoiced": "Facturé",
		"Just a moment please, your order is being added to your shopping cart...": "Veuillez patienter, traitement des données en cours...",
		"Just a moment please, your order is being processed...": "Veuillez patienter, fichier en cours d’importation… ",
		"Klaar voor de winter?": "Prêt pour l'hiver? ",
		"Language": "Langue",
		"Learn more": "En savoir plus",
		"Lees meer": "Lire plus",
		"Limited stock!": "Stock limité !",
		"Location": "Emplacement",
		"Log in": "Connexion",
		"Log in with other pharmacy:": "Se connecter avec une autre pharmacie",
		"Max": "Max",
		"Max. discount": "Max. réduction",
		"Media": "Média",
		"Meer Details": "Plus de détails",
		"Mijn verzendingen": "Mijn verzendingen",
		"Mijn verzendingen bekijken": "Mijn verzendingen bekijken",
		"Mocht u verdere vragen hebben, kan u steeds terecht bij uw vertrouwde relatiebeheerder.": "Pour toute question à ce sujet, merci de prendre contact avec votre chargé(e) de relations.",
		"Modify": "Modifier",
		"Modify password": "Modifier mot de passe",
		"Month": [
			"mois",
			"mois"
		],
		"More info": "En savoir plus",
		"More info about": "More info about",
		"More info about 'special orders'.": "En savoir plus de 'Commande spéciales'.",
		"More than one pharmacy is linked to your account. Choose the pharmacy you wish to log on with.": "Plusieurs pharmacies sont liées à votre compte. Choisissez la pharmacie avec laquelle vous voulez vous connecter.",
		"More than one seller is linked to your account. Choose the seller you wish to log on with.": "Plusieurs fournisseurs sont liés à votre compte. Choisissez le fournisseur avec lequel vous voulez vous connecter.",
		"My account": "Mon compte",
		"My contracts": "Mes contrats",
		"My log in data": "Mes identifiants",
		"My orders": "Mes commandes",
		"My packages": "Mijn verzendingen",
		"My pharmacy": "Ma pharmacie",
		"My rent overview": "Mes demandes de location",
		"My reservations": "Mes Réservations",
		"Febelco organiseert naar jaarlijkse gewoonte een voorverkoop van griepvaccins, en dat tot en met 28 februari 2021.": "Febelco organise comme chaque année une prévente de vaccins antigrippaux, et ce jusqu'au 28 février 2021.",
		"Name": "Nom",
		"Name or APB or client number": "Nom ou APB ou numéro de client",
		"New order date must be before current order date": "Nouvelle date de livraison doit être antérieure à la date de livraison prévue.",
		"New order date must be later than today": "Nouvelle date de livraison doit être postérieure à aujourd'hui.",
		"Newest": "Dernières",
		"News": "Nouvelles",
		"News for": "Nouvelles pour",
		"News overview cannot be shown": "Fil d’actualité non disponible.",
		"Next": "Suivant",
		"Next Century": {
			"Datetimepicker tooltips": "Siècle suivant"
		},
		"Next Decade": {
			"Datetimepicker tooltips": "Décennie suivante"
		},
		"Next Month": {
			"Datetimepicker tooltips": "Mois suivant"
		},
		"Next Year": {
			"Datetimepicker tooltips": "Année suivante"
		},
		"No": "Non",
		"No certificates found for the given search criteria.": "Aucun certificat n'a été trouvé pour les critères de recherche saisis.",
		"No orders found": "Aucun résultat ne correspond à vos critères de recherche",
		"No passed rental products the last 3 months.": "Aucune demande de location n'a été terminée ces trois derniers mois.",
		"No products found.": "Produit introuvable.",
		"No results.": "Aucun résultat.",
		"No stock available": "Hors stock ",
		"Non Rental Products": "Produits achetés",
		"Non-binding recommended prices": "Prix conseillés non contraignants",
		"Not available": "Non disponible",
		"Note": "Remarque",
		"Notices": "Notices",
		"Notices for patient": "Notice pour patient",
		"N°": "N°",
		"N° displays": "N° displays",
		"OP=OP": "À saisir",
		"One or more products were not found": "Un ou plusieurs produit(s) introuvable(s)",
		"Only {{productDiscount.counter}} piece(s) left!": "Plus que {{productDiscount.counter}} article(s) disponibles.",
		"Only {{vm.counter}} piece(s) left!": "Plus que {{vm.counter}} articles disponibles.",
		"Onze externe partner, ESRI, kan pas 24u na het moment van aanvraag leveren. Wenst u een dringende aanvraag (bijv. voor een palliatieve patiënt), neem dan even contact met de thuiszorgafdeling van Febelco via tgz@febelco.be of via het nummer 03/292.24.72. Zij bekijken dan samen met de externe partner wat er mogelijk is.": "Notre partenaire externe, ESRI, ne peut livrer que 24 heures après le moment de votre demande. Si vous avez besoin d'une demande urgente (par exemple pour un patient en soins palliatifs), veuillez contacter le service SÀD de Febelco par sad@febelco.be ou par le numéro 03/292.24.72. Ils examinent ensuite avec le partenaire externe ce qui est possible.",
		"Op {{vm.rentedProductsOrder.deliveryInfo.deliveryDate | date}} zullen de product(en) geleverd worden op uw gekozen leveradres": "Le(s) produit(s) seront livrés à votre adresse de livraison le {{vm.rentedProductsOrder.deliveryInfo.deliveryDate | date}}.",
		"Op=Op? These is the last stock for certain products for an extra discounted price. These products can not be returned.": "À saisir ? Ce sont des produits presque épuisés ne pouvant pas être retournés à un prix très avantageux. Visitez régulièrement notre site et découvrez chaque mois nos nouvelles promotions !",
		"Opgelet, de aangeduide aantallen griepvaccins op deze pagina geven uw initiële, totale reservatie griepvaccins weer. De aantallen houden met andere woorden geen rekening met eventueel reeds geleverde griepvaccins.": "Attention : les quantités de vaccins antigrippaux sur cette page correspondent à la quantité totale de votre réservation initiale. Autrement dit, ces quantités ne tiennent pas compte des vaccins antigrippaux déjà livrés.",
		"Order": {
			"noun": "Commander",
			"verb": "Commander",
			"$$noContext": "Commande"
		},
		"Order - noun": "Commande",
		"Order confirmation": "Confirmer commande",
		"Order here": "Commander ici",
		"Order now": "Commander maintenant",
		"Order pack": "Commander le promopack",
		"Order panaché": "Découvrez les conditions panaché et passez vos commandes",
		"Order total": "Total commande",
		"Order total price": "Réduction sur la totalité de votre commande",
		"Ordered products": "Produits",
		"Orders are pharmacy based. When you log on as another pharmacy, your shopping basket will change. Your current shopping basket is however not removed.": "Les commandes se font par pharmacie. Si vous vous connectez avec une autre pharmacie, le panier sera modifié. Votre panier actuel ne sera toutefois pas supprimé. ",
		"Orders in Profficina are pharmacy based. Once logged on, you can always switch pharmacy through the 'My account' link in the menu.": "Les commandes dans Profficina se font par pharmacie. Dès que vous êtes connecté, vous pouvez toujours changer de pharmacie en cliquant sur le lien ‘Mon compte’ dans le menu.",
		"Other offers with this product": "Autres offres avec ce produit",
		"Our website uses cookies to make your browsing experience better. By using our site, you agree to our use of cookies.": "Ce site utilise des cookies pour améliorer votre expérience de navigation. Si vous poursuivez la navigation, nous considérerons que vous acceptez leur utilisation.",
		"Outlet": "À saisir",
		"Overview": "Aperçu",
		"Overview all discounts": "Aperçu réductions",
		"Overzicht producten in reservatie": "Mes réservations",
		"PDF": "PDF",
		"PROMO": "PROMO",
		"Package quantity": "Quantité de colis",
		"PackageDetail": "Details verzending",
		"Packages archive": "Al mijn verzendingen",
		"Panaché": "Panaché",
		"Panaché:": "Panaché:",
		"Partially in progress by wholesaler": "Commande partiellement en cours de de traitement",
		"Partially invoiced": "Facturé partiellement",
		"Partially registered by wholesaler": "Enregistré partiellement ",
		"Partnerships": "Partenariats",
		"Password": "Mot de passe",
		"Pharmacy": "Pharmacie",
		"Pharmacy price": "Prix pharmacien",
		"Pick Hour": {
			"Datetimepicker tooltips": "Choisissez l'heure"
		},
		"Pick Minute": {
			"Datetimepicker tooltips": "Choisissez minutes"
		},
		"Pick Second": {
			"Datetimepicker tooltips": "Choisissez secondes"
		},
		"Place order": "Commander",
		"Please enter a date before {{vm.maxDate | date: 'dd-MM-yyyy'}}": "Veuillez choisir une date antérieure au {{vm.maxDate | date: 'dd-MM-yyyy'}}",
		"Please enter a date in the future": "Veuillez ajouter une date valable.",
		"Please enter a quantity.": "Entrez une quantité. ",
		"Please place your order within {{error.daysLeftUntilDiscountExpires}} days, discount for {{error.productName}} ends on {{error.expireDate | date:'yyyy-MM-dd'}}": "Veuillez passer votre commande dans les {{error.daysLeftUntilDiscountExpires}} jours, la réduction pour {{error.productName}} expire le {{error.expireDate | date:'yyyy-MM-dd'}}",
		"Please provide a street.": "Veuillez ajouter une rue.",
		"Please provide a valid city.": "Veuillez ajouter une ville valable.",
		"Please provide your contact person.": "Veuillez ajouter une personne à contacter.",
		"Please provide your housenumber.": "Veuillez ajouter votre numéro de maison.",
		"Please provide your telephone number.": "Veuillez ajouter votre numéro de téléphone.",
		"Please refine your search.": "Affinez votre recherche...",
		"Please select a pharmacy": "Sélectionnez une pharmacie",
		"Please select a seller": "Sélectionnez un fournisseur",
		"Prescription": "Sur prescription",
		"Previous": "Dernier",
		"Previous Century": {
			"Datetimepicker tooltips": "Siècle précédent"
		},
		"Previous Decade": {
			"Datetimepicker tooltips": "Décennie précédente"
		},
		"Previous Month": {
			"Datetimepicker tooltips": "Mois précédent"
		},
		"Previous Year": {
			"Datetimepicker tooltips": "Année précédente"
		},
		"Price": "Prix",
		"Price information": "Informations prix",
		"Price:": "Prix:",
		"Processing...": "Traitement en cours…",
		"Product": "Produit",
		"Product available": "Produit disponible",
		"Product discount": "Réduction produit",
		"Product info": "Informations produit",
		"Product information": "Informations produit",
		"Product name or number": "Nom ou numéro du produit",
		"Product name, number or lot number": "CNK, nom produit ou n° lot",
		"Product not found": "Numéro de produit introuvable",
		"Product number": "CNK",
		"Product number or product name": "Cnk ou nom produit",
		"Product number, name product": "Numéro de produit, nom du produit",
		"Product overview cannot be shown": "Aperçu produits non disponible",
		"Product status": "Statut produit",
		"Product vervalt op {{productDiscount.expirationDate | date: 'dd/MM/yyyy'  }}": "Date de péremption : {{productDiscount.expirationDate | date: 'dd/MM/yyyy'}}",
		"ProductNumber": "ProductNumber",
		"Producten die mogelijks\n                                            interessant zijn om bij te huren": "Produits intéressants à louer en addition de votre commande",
		"Producten die mogelijks\n                                            interessant zijn om bij te kopen": "Produits intéressants à acheter en addition de votre commande",
		"Producten die mogelijks interessant zijn om bij te huren": "Produits intéressants à louer en addition de votre commande",
		"Producten die mogelijks interessant zijn om bij te kopen": "Produits intéressants à acheter en addition de votre commande",
		"Productname or product number": "Nom produit ou numéro de produit",
		"Products": "Produits",
		"Products were added to your cart": "Les produits ont été ajoutés au panier.",
		"Profficina": "Profficina",
		"Profficina Ref.": "Profficina Réf.",
		"Profficina ref.": "Profficina Réf.",
		"Profficina ref. or TO-nr.": "Profficina Réf. ou TO N° bon",
		"Promopack": "Promopack",
		"Properties": "Propriétés",
		"Public categories": "Catégories publiques",
		"Public price": "Prix public",
		"Quantity": "Quantité",
		"Quantity in panaché": "Qté en panaché",
		"Quantity:": "Quantité",
		"Questions or remarks concerning the pharmacovigilance of one of our products?": "Des questions ou des remarques sur la pharmacovigilance d’un de nos produits ? ",
		"Questions? More info?": "Des questions ? En savoir plus ?",
		"Read more": "Plus d'infos",
		"Read our FAQ": "Consultez notre FAQ",
		"Receipt": "Note de commande",
		"Recently passed rental products": "Locations terminées récemment",
		"Reference codes": "Codes de références",
		"Refund value with omnio": "Tarif Omnio",
		"Refund value without omnio": "Tarif de remboursement",
		"Refunded deposit": "Restitution caution",
		"Registered": "Enregistré",
		"Registered by seller": "Enregistré par le fournisseur",
		"Related news": "Actualités liées",
		"Rent": {
			"Verb": "Louer"
		},
		"Rent per day": "Prix de location par jour",
		"Rent per day:": "Prix de location par jour:",
		"Rent products": "Produits de location",
		"Rental amount per month": "Prix de location par mois",
		"Rental products": "Produits de location",
		"Rental products in your possession": "Locations en cours",
		"Rental request (Pdf)": "Demande (PDF)",
		"Rental service": "Location",
		"Rented from": "Loué depuis le",
		"Rented product detail": "Détails produit de location",
		"Rented since – until": "Loué du &ndash; au",
		"Rented until": "Loué jusqu'au",
		"Rented until – from": "Loué du &ndash; au",
		"Reorder": "Dupliquer commande",
		"Replacement product available": "Produit de remplacement disponible ",
		"Required&nbsp;{{vm.product.minOrderAmount}}": "{{vm.product.minOrderAmount}}&nbsp; pièces requises",
		"Reservation time": "Réservé depuis",
		"Reservation time:": "Réservé depuis:",
		"Reserved products at Febelco": "Aperçu des produits en réservation",
		"Reserveer nu uw griep vaccins": "Réservez vos vaccins contre la grippe ici.",
		"Reset": "Supprimer",
		"Retroactive discount": "Réduction rétroactive",
		"Return": "Retour",
		"Return to the homepage": "Retour à la page d’accueil",
		"Route number": "Numéro de route",
		"Running low on stock!": "Stock presque épuisé !",
		"Save": "Enregistrer",
		"Scientific notices": "Notice scientifique",
		"Search": "Rechercher",
		"Search by contract name": "Recherche par nom contrat",
		"Search by name": "Recherche par nom",
		"Search by name or number": "Recherche par nom ou code Numéro de produit",
		"Search products by number or name": "Recherche produits par nom ou code Numéro de produit",
		"See the latest discounts": "Consultez les dernières réductions",
		"Select Decade": {
			"Datetimepicker tooltips": "Sélectionnez décennie"
		},
		"Select Month": {
			"Datetimepicker tooltips": "Sélectionnez mois"
		},
		"Select Year": {
			"Datetimepicker tooltips": "Sélectionnez année"
		},
		"Select other pharmacy": "Sélectionnez une autre pharmacie",
		"Select other seller": "Sélectionnez un autre fournisseur",
		"Select wholesaler": "Sélectionnez grossiste",
		"Seller": "Fournisseur",
		"Sellers": "Fournisseurs",
		"Send a fax to": "Envoyez un fax au",
		"Send an e-mail to": "Envoyez un e-mail à",
		"Send application": "Envoyer demande",
		"Sent to seller": "Envoyé au fournisseur",
		"Serialnumber": "Numéro de série",
		"Shipping note": "Note d'envoi",
		"Shopping cart": "Panier",
		"Show all": "Afficher tout",
		"Show all results": "Afficher tous les résultats",
		"Show in grid": "Afficher dans un tableau",
		"Show in list": "Afficher dans une liste",
		"Show less": "Afficher moins",
		"Side effects": "Effets secondaires",
		"Sign out": "Se déconnecter",
		"Sold out!": "Trop tard !",
		"Something went wrong": "Une erreur est survenue.",
		"Something went wrong when loading this page.": "Une erreur est survenue lors du chargement de cette page.",
		"Something went wrong while adding the products to your shoppingcart.": "Une erreur est survenue. Les produits n’ont pas pu être ajoutés au panier.",
		"Something went wrong while adding your products, please try again.": "Une erreur est survenue. Les produits n’ont pas pu être ajoutés au panier.",
		"Something went wrong with the import of your file. Please check your CSV and try again.": "Une erreur est survenue lors de l’importation du fichier CSV. Veuillez vous assurer que le fichier est correct et réessayer. ",
		"Sort": "Trier",
		"Sort by": "Trier par",
		"Special Discounts": "Speciale kortingen (FR)",
		"Special order possible": "Commande spéciale possible",
		"Special orders": "Commandes spéciales",
		"Status": "État",
		"Stock response cannot be checked at the moment.": "Le stock n’est actuellement pas consultable.",
		"Street": "Rue",
		"Subtotal": "Sous-total",
		"Suggesties": "Suggestions",
		"Supplier": "Fournisseur",
		"Supplier has no stock available": "Non tenu en stock par le fournisseur",
		"Supplier reference": "Référence fournisseur",
		"TO-nr.": "TO N° bon",
		"Tags": "Étiquettes",
		"Tax": "TVA",
		"Tel:": "Tél:",
		"Telephone number": "Numéro de téléphone",
		"Thank you for ordering": "Merci de votre commande.",
		"The Agios discount is not known, contact the supplier for more info.": "Réduction Agios inconnue. Pour en savoir plus, veuillez prendre contact avec le fournisseur.",
		"The CSV was empty.": "Le fichier CSV est vide. Veuillez vous assurer que le fichier est correct et réessayer.",
		"The last 3 months you did not submit any rental applications via Profficina.": "Aucune demande de location n'a été faite sur Profficina ces trois derniers mois.",
		"The last 3 months, you ended rent for more than 15 products.": "Plus de 15 locations ont été terminées ces trois derniers mois.",
		"The orders could not be retrieved": "Une erreur s’est produite lors de l’affichage des commandes.",
		"The partnerships could not be retrieved": "Une erreur s’est produite lors de l’affichage des partenariats.",
		"The product could not be added to your shopping cart": "Le produit n’a pas pu être ajouté au panier.",
		"The product could not be removed from your shopping cart": "Le produit n’a pas pu être retiré du panier.",
		"The product quantity could not be updated": "La quantité du produit n’a pas pu être modifiée.",
		"The product you were looking was not found or is inactive.": "Le produit est introuvable ou est inactif.",
		"The products cannot be retrieved.": "Une erreur s’est produite lors de l’affichage des produits.",
		"The products could not be removed from your shopping cart": "Le produit n’a pas pu être retiré du panier.",
		"The quantity of one or more products is incorrect.": "Un ou plusieurs produit(s) ne renseigne(nt) pas la quantité.",
		"The shaded products can no longer be ordered.": "Les produits hachurés ne peuvent plus être commandés.",
		"There are currently no discounts available": "Aucun réduction n’est actuellement disponible.",
		"There are currently no products available": "Aucun produit n’est actuellement disponible.",
		"There are still products in your shopping cart": "Il y a encore des produits dans votre panier",
		"This product is in Agios, the discount displayed is not the Agios discount.": "Ce produit fait partie d'Agios, la réduction affichée n'est pas une réduction Agios.",
		"This promopack contains following products": "Ce paquet de promotion contient les produits suivants",
		"Time": "Moment",
		"To TGZ homepage": "Retour à la page d'accueil sad",
		"Too many results.": "Plus de 20 résultats.",
		"Total": "Total",
		"Total (incl. VAT)": "Total (TVA incluse)",
		"Total discount": "Réduction totale",
		"Total quantity in panaché": "Quantité totale en panaché",
		"Total rent": "Prix de location total",
		"Trade in months after expiry": "Échange en mois après expiration",
		"Trade in months before expiry": "Trade in months before expiry",
		"U heeft momenteel geen openstaande reservaties.": "Vous n’avez aucune réservation ouverte en ce moment.",
		"U heeft voor dit partnership een {{contract.name}} contract van onbepaalde duur vanaf {{contract.startDate | date}}": "Pour ce partenariat, vous avez un contrat {{contract.name}} de durée indéterminée ayant pris effet le {{contract.startDate | date}}.",
		"U heeft voor dit partnership een {{contract.name}} contract van {{contract.startDate | date}} tot {{contract.endDate | date}}": "Pour ce partenariat, vous avez un contrat {{contract.name}} du {{contract.startDate | date}} au {{contract.endDate | date}}",
		"Undo changes": "Annuler changements",
		"Unfortunately there are no products available for the current criteria.": "Aucun produit ne correspond aux critères sélectionnés.",
		"Unfortunately there were no certificates found.": "Aucun certificat n'est actuellement disponible.",
		"Unfortunately there were no items found from Profficina.": "Aucune demande de location n'a été faite sur Profficina.",
		"Unfortunately there were no news items found.": "Aucune nouveauté ne correspond aux critères sélectionnés.",
		"Unfortunately there were no partnerships found.": "Aucun avantage ne correspond aux critères sélectionnés.",
		"Unfortunately there were no rental products found.": "Produits de location introuvables.",
		"Unfortunately there were no rental requests found.": "Aucune demande de location n’a été trouvée.",
		"Until": "Au",
		"Up to": "Jusqu’à",
		"Update cart": "Mise à jour panier",
		"Update shopping cart [ENTER]": "Mettre à jour panier [ENTER]",
		"Updating your cart...": "Mise à jour panier en cours...",
		"Usage": "Utilisation",
		"Uw aanvraag": "Votre demande",
		"Uw contract": "Votre contrat",
		"Uw gereserveerde griepvaccins zijn toegevoegd aan onderstaande lijst van reservaties echter kunnen we geen nieuwe reservaties meer opnemen.": "Vos vaccins antigrippaux réservés ont été ajoutés à la liste des réservations ci-dessous, mais nous ne pouvons plus faire de nouvelles réservations.",
		"Uw huuraanvraag": "Votre demande de location",
		"Uw huuraanvraag is verstuurd naar de klantendienst.": "Votre demande de location a été envoyée au service clientèle.",
		"VAT": "TVA",
		"VAT:": "TVA:",
		"VAXIGRIP TETRA 2021-2022 0,5 ML 1 WWSP": "VAXIGRIP TETRA 2021-2022 0,5 ML 1 SER A JET",
		"Valid from": "Valable du   ",
		"Valid from - until": "Valable du - au",
		"Valid until": "Valable jusqu'à",
		"Vendor": "Fournisseur",
		"Verstuur": "Envoyer",
		"Verzending": "Verzending",
		"View my orders": "Mes commandes",
		"View my packages": "Mijn verzendingen bekijken",
		"View my rent overview": "Mes demandes de location",
		"View my reservations": "Mes réservations",
		"View your shopping basket": "Ouvrir votre panier",
		"Voor vragen of aanpassingen aan deze aanvraag, gelieve de klantendienst te contacteren op 03/770.70.70 of klantendienst@febelco.be": "Si vous avez des questions relatives à votre demande, ou si vous aimeriez faire des ajustements, veuillez contacter le service clientèle par téléphone au numéro [03/770.70.70] ou adressez-vous à klantendienst@febelco.be.",
		"We can not find the page you are looking for. The product / news item / ... may no longer exist.": "La page que vous demandez est introuvable. Il se peut que le lien vous avez utilisé ne soit plus valable.",
		"Weight": "Poids",
		"What would you like use to do <strong>when these products are not in stock</strong>?": "LE CAS ÉCHÉANT, <strong>QUE SOUHAITEZ-VOUS FAIRE?</strong>",
		"Wholesaler": "Grossiste",
		"Width": "Largeur",
		"active": "Actif",
		"inactive": "Inactif",
		"true": "Oui",
		"false": "Non",
		"Written request by patient": "Sur demande écrite du patient",
		"U kan uw vaccins uitsluitend reserveren via Profficina. We bevelen u van harte aan om uw aantallen goed in te schatten, zodat we op basis daarvan voldoende voorraad kunnen voorzien.": "Ces vaccins ne peuvent être réservés que sur Profficina. Nous vous recommandons vivement de bien estimer les quantités dont vous avez besoin, afin que nous puissions aligner notre stock sur celles-ci.",
		"Wij raden aan om\n                                            hierbij ook deze producten te huren": "Nous vous conseillons de louer les produits suivants en supplément",
		"Wij raden aan om\n                                            hierbij ook deze producten te kopen": "Nous vous conseillons d’acheter les produits suivants en supplément",
		"Wij raden aan om hierbij ook deze producten te huren": "Nous vous conseillons de louer les produits suivants en supplément",
		"Wij raden aan om hierbij ook deze producten te kopen": "Nous vous conseillons d’acheter les produits suivants en supplément ",
		"Withdrawn product": "Produit retiré du marché",
		"Maximum quantity exceeded.": "Maximum quantity exceeded.",
		"Year": "Année",
		"Yes": "Oui",
		"You are logged in with pharmacy": "Vous êtes connecté avec la pharmacie ",
		"You are logged in with seller": "Vous êtes connecté avec le fournisseur",
		"You are now logged in with pharmacy": "Vous êtes connecté avec la pharmacie ",
		"You can choose from the following products:": "Vous avez le choix parmi les produits suivants :",
		"You currently do not rent products from Febelco.": "Actuellement, vous ne louez pas de produits Febelco.",
		"You did not update your cart with the quantities you last modified.": "Les dernières quantités modifiées n’ont pas encore été ajoutées à votre panier.",
		"You do not have permission to view this page.": "Vous n’êtes pas autorisé à consulter cette page.",
		"You have more than 15 rental products in your possession.": "Vous louez actuellement plus de 15 produits.",
		"You have more than 15 rental requests in the last 3 months.": "Plus de 15 locations les derniers 3 mois.",
		"You have not rented products from Febelco.": "Vous n’avez loué aucun produit.",
		"You searched for": "Vos résultats de recherche pour",
		"You will receive an email confirmation shortly at {{ vm.mail }}.": "Une confirmation vous a été envoyée par courrier électronique à l’adresse {{ vm.mail }}.",
		"Your browser does not support file upload.": "Your browser does not support file upload.",
		"Your info": "Vos données",
		"Your purchases": "Vos achats",
		"Your recent rental requests": "Locations demandées récemment sur Profficina",
		"Your rent request on": "Demande du",
		"Your reservation has been confirmed.": "Votre réservation a bien été enregistrée.",
		"Your search value": "Votre terme de recherche",
		"Your shopping cart": "Votre panier",
		"_myDocuments._reportNarcotics.description": "Vous trouverez ici un aperçu des produits (contenant des substances énumérées dans les annexes I, II et IV de l’A.R. du 06/09/2017) pour lesquels vous ne nous avez pas encore remis de bon de stupéfiant.",
		"_myDocuments._reportNarcotics.title": "Bons de stupéfiant non traités",
		"_myDocuments._reportPurchaseProposals.description": "Ce rapport est un tableau récapitulatif de vos achats et indique clairement – pour chaque CNK – combien de pièces (1/5/10 pc.) vous devriez acheter pour pouvoir bénéficier d'une réduction maximale. Ces propositions vous aident également à limiter le nombre de livraisons d’un CNK au cours de la même période de facturation, et permettent ainsi d’augmenter votre efficacité.",
		"_myDocuments._reportPurchaseProposals.title": "Propositions d’achat",
		"_myDocuments._settings.introText": "Vous trouverez ici un aperçu des bons de stupéfiant que vous devez encore nous remettre, ainsi qu’un aperçu de vos propositions d’achat.",
		"_myDocuments._settings.myDocuments": "Mes documents",
		"_myDocuments._settings.viewMyDocuments": "Visionner documents",
		"_myDocuments._siteHeader.myDocuments": "Mes documents",
		"_myDocuments.downloadDocument": "Télécharger document",
		"_myDocuments.myDocuments": "Mes documents",
		"_selftests.linkToFaq": "Pour toutes vos questions sur le kit COVID, merci de prendre contact avec votre chargé(e) de relations.",
		"_reservationCampaigns.product": "Produit",
		"_reservationCampaigns.productNumber": "CNK",
		"_reservationCampaigns.quantity": "Quantité",
		"_reservationCampaigns.reservationConfirmed": "Votre réservation a bien été enregistrée.",
		"_reservationCampaigns.save": "Réserver",
		"_reservationCampaigns.totalLimitReached": "Limite de réservation atteinte.",
		"_reservationCampaigns.limitReached": "Maximum {{limit}} pc.",
		"article": [
			"article",
			"articles"
		],
		"at": {
			"delivered on april 14th AT 17:25": "à"
		},
		"can be delivered on": "Ces produits pourront être livrés au plus tôt le ",
		"certificate": [
			"certificat",
			"certificats"
		],
		"checkout.agreeWithTerms": "En cliquant sur \"Confirmer commande\", vous acceptez les <a href=\\\"http://www.profficina.be/nl/algemene-voorwaarden.html\\\" class=\\\"link link-primary\\\" target=\\\"_blank\\\">conditions générales d’utilisation de Profficina</a>.",
		"checkout.contactSupportWhenInvoiceAddressIsIncorrect": "Si ces informations ne sont pas correctes, veuillez prendre contact avec <a href=\"mailto:support@profficina.be\">support@profficina.be</a>.",
		"checkout.linkToOrderOverview": "Vous pouvez toujours consulter les détails de vos commandes via 'Mon compte' <i class=\"ico ico-angle-right\"></i> '<a ui-sref=\"order-overview\" class=\"link link-primary\">Mes commandes</a>' en haut de la page.",
		"discount": "réduction",
		"discounts": "réductions",
		"documents": "documents",
		"indefinite": "pour une durée indéterminée",
		"indefinitely": "durée indéterminée",
		"news": "nouvelles",
		"no": "non",
		"or Send an email to": "ou envoyez un e-mail à",
		"parcel.addAnotherLine": "Ajouter un colis",
		"parcel.addConfirmationExplanations": "Een woordje uitleg wat men nu moet doen   ... Text TBD",
		"parcel.allMyParcels": "Tous mes envois",
		"parcel.back": "Précédent",
		"parcel.backToOverview": "Retour à l’aperçu",
		"parcel.barcode": "Code-barres",
		"parcel.cancel": "Annuler envoi",
		"parcel.cancelParcel": "Annuler colis",
		"parcel.checkData": "Vérifiez les données ci-dessus et confirmez que vous êtes d'accord avec",
		"parcel.confirmOrder": "Confirmer envoi",
		"parcel.createParcel": "Créer envoi",
		"parcel.createShippingLabelHere": "Envoyer un colis à une pharmacie via Febelco ? Créez une étiquette d'envoi ici.",
		"parcel.customerNumber": "Numéro client Febelco",
		"parcel.deliveredWithin48": "Binnen 48u geleverd op bestemming",
		"parcel.enterLicenseNumberLong": "Saisissez le numéro d'autorisation de la pharmacie où votre colis doit être livré. L'adresse du destinataire sera automatiquement affichée sur le prochain écran.",
		"parcel.enterLicenseNumberShort": "Veuillez saisir numéro d'autorisation.",
		"parcel.febelcoNotResponsibleForContent": "Febelco n'est pas responsable du contenu des colis.  ",
		"parcel.followWithTrackAndTrace": "Suivi via le système Track & Trace",
		"parcel.giveParcelToCourier": "Geef uw pakket met label aan de Febelco koerier",
		"parcel.hereYouCanRegister": "Ici, vous pouvez enregistrer un colis à envoyer à une autre pharmacie via Febelco, et suivre le statut de vos envois.",
		"parcel.howDoesItWork": "Hoe werkt het?  ..TBD",
		"parcel.iAgreeToTheTerms": "Je suis d'accord avec les termes et conditions.",
		"parcel.latestShipments": "Les envois des 6 derniers mois",
		"parcel.licenseNumber": "Numéro d'autorisation",
		"parcel.licenseNumberShort": "N° d'autorisation",
		"parcel.isSigned": "Recevoir la signature",
		"parcel.insurance": "Assurance",
		"parcel.insuranceDescription": "Prix ​​€{{insurancePrice}}. Si le colis est assuré, une signature sera également demandée lors de sa réception.",
		"parcel.required": "Obligatoire",
		"parcel.packageValue": "Valeur d'un forfait",
		"parcel.packagePrice": "Prix du coffret: ",
		"parcel.packageDiscount": "Pakket korting: ",
		"parcel.insuranceInvoiceAmount": "Prix ​​facturé pour l'assurance : ",
		"parcel.packageInvoiceAmount": "Prix ​​facturé pour le forfait: ",
		"parcel.freePackage": "Ce forfait est gratuit, toute assurance complémentaire sera toujours facturée.",
		"parcel.line": [
			"colis",
			"colis"
		],
		"parcel.madeOn": "Créé le",
		"parcel.myParcels": "Mes envois",
		"parcel.nameApbOrCustomerNr": "Nom, n° APB, n° client",
		"parcel.next": "Suivant",
		"parcel.no": "Non",
		"parcel.noParcelsFound": "Aucune expédition trouvée.",
		"parcel.noParcelsFoundForCriteria": "Aucun envoi ne correspond aux données saisies.",
		"parcel.noPharmacyFound": "Aucune pharmacie ne correspond aux données saisies.",
		"parcel.orderNumber": "Envoi ID ",
		"parcel.packLower": [
			"colis",
			"colis"
		],
		"parcel.packages": "Colis",
		"parcel.parcel": "Expédition",
		"parcel.parcelBarcode": "Code-barres colis",
		"parcel.parcelCancelCommandSent": "Veuillez patienter, l'annulation de votre colis ou envoi est en cours.",
		"parcel.errorSendingCancelCommand": "Un problème est survenu lors de l'annulation de votre colis ou de votre envoi.",
		"parcel.parcelLower": [
			"expédition",
			"verzendingen"
		],
		"parcel.perPage": "par page",
		"parcel.pleaseAgreeToTerms": "Veuillez accepter les termes et conditions.",
		"parcel.pleaseSelectPackageType": "Veuillez indiquer le type de colis que vous souhaitez envoyer. ",
		"parcel.printAndHandToDriver": "Imprimez les étiquettes d'envoi et remettez le colis à votre chauffeur.",
		"parcel.printLabel": "Imprimer étiquette d'envoi",
		"parcel.remarkForCourier": "Remarque / Message pour le courrier",
		"parcel.remarkForCourierDescription": "Ici, vous pouvez ajouter des renseignements supplémentaires ou des instructions pour le courrier.",
		"parcel.reset": "Supprimer",
		"parcel.search": "Rechercher",
		"parcel.searchAllParcels": "Recherchez un de vos envois ou créez un nouvel envoi.",
		"parcel.sendTo": "Envoyer à",
		"parcel.sentTo": "Destinataire",
		"parcel.shippingDetail": "Détails envoi",
		"parcel.shippingDetails": "Détails envoi",
		"parcel.signatureRequired": "Signer à la réception",
		"parcel.signatureRequiredDescription": "Lorem ipsum dolor sit amet...",
		"parcel.theConditions": "les termes et conditions.",
		"parcel.to": "À l'adresse suivante",
		"parcel.trackAndTraceInDetail": "L'activité Track & Trace en détail",
		"parcel.until": "jusqu'au",
		"parcel.viewMyParcels": "Voir mes envois",
		"parcel.whatCanBeSentAndHowItWorks": "Een woordje uitleg over wat men kan verzenden en hoe het werkt.",
		"parcel.whatToSend": "Que voulez-vous expédier ?",
		"parcel.whichPharmacyToSend": "À quelle pharmacie souhaitez-vous envoyer un colis ?",
		"parcel.yes": "Oui",
		"parcel.youHaveNoRecentParcels": "Aucun envoi n'a été enregistré récemment.",
		"parcel.yourParcelWasRegistered": "Votre envoi a été enregistré.",
		"partnerships": "partenariats",
		"pcs.": "pc.",
		"per page": "par page",
		"product": [
			"produit",
			"produits"
		],
		"product.medipim.expires": "Date de péremption",
		"product.medipim.refundValueWithOmnio": "Tarif Omnio",
		"product.medipim.refundValueWithoutOmnio": "Tarif de remboursement",
		"product.medipim.tradeInMonthsAfterExpiry": "Période d'échange après la date de péremption",
		"product.medipim.tradeInMonthsBeforeExpiry": "Période d'échange avant la date de péremption",
		"product.status.active": "Actif",
		"product.status.inactive": "Inactif",
		"product.status.replaced": "Remplacé",
		"products": "Produits",
		"products available in your warehouse": "produits disponibles dans votre siège. ",
		"products available": "produits disponibles",
		"refundOnDate": "le",
		"rental product": [
			"produit de location",
			"produits de location"
		],
		"rental request": [
			"demande de location",
			"demandes de location"
		],
		"select file": "sélectionnez un fichier",
		"tour": "tournée",
		"until": "au",
		"upward of": "à partir de",
		"v.a. {{d.amount}} st.": "À partir de {{d.amount}} pc.",
		"vac test": "\"Dès aujourd’hui, vous pouvez réserver vos vaccins exclusivement sur la plateforme d’achat Profficina. Vous pouvez égalementy consulter les réductions par produit, et les quantités réservées. Facile, non ?Vous n’avez pas encore de compte sur Profficina ? Prenez contact avec votre chargé de relations, ou envoyez un e-mail àsupport@profficina.be.\"",
		"yes": "oui",
		"{{ vm.activeCategory ? vm.activeCategory.name : 'All rental products'}}": "{{ vm.activeCategory ? vm.activeCategory.name : 'Tous les produits de location'}}",
		"_order.selectAccountTitle": "Sélectionnez votre compte client",
		"Dear Pharmacist,": "Cher pharmacien,",
		"From 23/01/2023 <strong>you</strong> and anyone who gives you rights, <strong>can manage the reservations yourself</strong> via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a>, our new customer portal: changing, removing or adding can then be done in a few mouse clicks.": "À partir du 23/01/2023, vous et tous ceux à qui vous donnez les droits pourront simplement gérer les réservations via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a>: vous pouvez les modifier, les supprimer ou les ajouter en quelques clics.",
		"Via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a> you also get direct access to all kinds of information, personal data and useful tools. Calling customer service is no longer necessary, so they have more time to help our customers on the line faster.": "Vous bénéficiez également via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a> d'un accès direct à toutes sortes d'informations, de données personnelles et d'outils utiles. Il ne sera plus nécessaire d'appeler le service client, ils auront donc plus de temps pour aider nos clients en ligne plus rapidement.",
		"Due to this progress, the <strong>reservation overview</strong> will no longer be available on Profficina and your secure area (my Febelco) <strong>from 16/01</strong>.": "En raison de cette évolution, l'aperçu des réservations ne sera plus disponible sur Profficina et votre zone sécurisé (mon Febelco) à partir du 16/01.",
		"<strong>Questions?</strong><br>Before you can go to MyFebelco, you must activate your account on the basis of a registration email.": "<strong>Des questions?</strong><br>Avant de pouvoir accéder à MyFebelco, vous devez activer votre compte sur la base d'un email d'inscription.",
		"Didn't receive a registration email? Then contact <a href=\"mailto:support@myfebelco.be\" class=\"link\">support@myfebelco.be</a>.": "Vous n'avez pas reçu d'e-mail d'inscription? Alors contactez <a href=\"mailto:support@myfebelco.be\" class=\"link\">support@myfebelco.be</a>."
	}
};


//////////////////
// WEBPACK FOOTER
// ./assets/po/fr.po
// module id = 684
// module chunks = 0